import { action } from 'typesafe-actions';

export const putError = (message: string, type: string) => action(type, message);
